import styled from "@emotion/styled";
import {
  SortableCustomTable,
  Text,
} from "@totalenergiescode/mobility-business-rev-design-system";

import { MemoizedPageHeader as PageHeader } from "@/components/shared/PageHeader/component";

export const StyledCustomTableContainer = styled("div")`
  padding-inline: 20px;

  && tr:hover {
    background-color: transparent !important;
  }
`;

export const StyledCurrentCountOnTotalText = styled(Text)`
  color: ${({ theme }) => theme.palette.grey[500]};
  text-align: center;
`;

export const StyledCurrentCountOnTotalContainer = styled("div")`
  padding-block: 14px;
`;

export const StyledPageHeader = styled(PageHeader)`
  justify-content: space-between;
  padding: 0 40px 20px 40px;
`;

export const StyledSortableCustomTable = styled(SortableCustomTable)`
  margin-left: 20px;
`;

export const StyledCard = styled("div")`
  margin: 20px 0 20px 40px;
  padding: 20px 0 20px 20px;
  background-color: ${({ theme }) => theme.palette.grey[50]};
  border-radius: 8px;
`;

export const StyledCountNotificationsText = styled(Text)`
  margin: 20px 0 20px 40px;
`;

export const StyledEmailText = styled(Text)`
  color: ${({ theme }) => theme.palette.grey[500]};
`;
